import { ICellRendererParams } from "ag-grid-community";
import { memo } from "react";

export enum CellRendererType {
  TEXT = "text",
}

interface CellRendererParams extends ICellRendererParams {
  cellRendererType?: CellRendererType;
}

const TextCellRenderer = memo(({ value }: ICellRendererParams) => (
  <span>{value !== null && value !== undefined ? String(value) : ""}</span>
));

TextCellRenderer.displayName = "TextCellRenderer";

const CellRenderer = memo(({ cellRendererType, ...params }: CellRendererParams) => {
  const type = cellRendererType ?? CellRendererType.TEXT;

  switch (type) {
    case CellRendererType.TEXT:
      return <TextCellRenderer {...params} />;
    default:
      return <TextCellRenderer {...params} />;
  }
});

CellRenderer.displayName = "CellRenderer";

export default CellRenderer;
